import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRightLeft, Loader2 } from "lucide-react";
import api from "../lib/api";

export function RedirectGate({ page, children }) {
  const [state, setState] = useState(null);
  useEffect(() => {
    const check = () => api.get("/public/redirects", { params: { t: Date.now() }, headers: { "Cache-Control": "no-cache" } }).then((r) => setState(r.data[page] || { enabled: false })).catch(() => setState((s) => s || { enabled: false }));
    check();
    const id = setInterval(check, 5000);
    const onVis = () => { if (!document.hidden) check(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVis); };
  }, [page]);
  if (!state) return null;
  if (state.enabled) return <Navigate to={state.target} replace />;
  return children;
}

const PAGES = [["lawfirm", "/lawfirm", "marketing page"], ["organizations", "/organizations", "page"]];

function RedirectCard({ k, path, label, item, busy, onToggle }) {
  const on = !!item?.enabled;
  const target = item?.target || `${path}/login`;
  return (
    <div className="surface hairline rounded-2xl p-5 flex flex-wrap items-center gap-4" data-testid={`redirect-card-${k}`}>
      <ArrowRightLeft size={18} className="text-primary shrink-0" />
      <div className="flex-1 min-w-[220px]">
        <div className="font-semibold"><code>{path}</code> {label}</div>
        <p className="text-[12.5px] text-muted-foreground mt-0.5" data-testid={`redirect-status-${k}`}>{on ? <>Redirect is <b className="text-amber-400">on</b> — visitors are sent to <code>{target}</code> and the page isn't shown.</> : <>Redirect is <b className="text-emerald-400">off</b> — the page renders normally.</>}</p>
      </div>
      <button onClick={onToggle} disabled={busy} role="switch" aria-checked={on} data-testid={`redirect-toggle-${k}`} className={`relative w-12 h-7 rounded-full transition-colors ${on ? "bg-primary" : "bg-white/15"} disabled:opacity-50`}>
        <span className={`absolute top-1 left-0 w-5 h-5 rounded-full bg-white transition-transform ${on ? "translate-x-6" : "translate-x-1"}`} />
      </button>
    </div>
  );
}

export default function PlatformRedirects() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => { api.get("/public/redirects").then((r) => setData(r.data)).catch(() => setData({})); }, []);
  const toggle = async (k) => {
    setBusy(k);
    try { const r = await api.put(`/platform/redirects/${k}`, { enabled: !data[k]?.enabled }); setData(r.data); toast.success(r.data[k].enabled ? "Redirect enabled" : "Page restored"); } catch (e) { toast.error(e.response?.data?.detail || "Could not update"); }
    setBusy(null);
  };
  if (!data) return <Loader2 className="animate-spin text-muted-foreground" size={18} />;
  return (
    <div className="max-w-2xl space-y-3" data-testid="platform-redirects">
      {PAGES.map(([k, path, label]) => <RedirectCard key={k} k={k} path={path} label={label} item={data[k]} busy={busy === k} onToggle={() => toggle(k)} />)}
    </div>
  );
}
